import React, { useMemo } from 'react'

import { Card, CardContent, Grid } from '@mui/material'
import { useWatch } from 'react-hook-form'
import { useParams } from 'react-router-dom'

import { FormSelect } from 'components/input'
import LoadingView from 'components/LoadingView'
import { withForm } from 'decorators/withForm'
import { useCampaignHealth } from 'hooks/useCampaignHealth'
import { getStatsData } from 'selectors/campaign-health-selectors'

import CampaignHealthCharts from './CampaignHealthCharts'
import CampaignHealthStats from './CampaignHealthStats'
import CampaignHealthTable from './CampaignHealthTable'

const timeAggregationOptions = Object.entries({
  daily: 'Daily',
  weekly: 'Weekly',
  monthly: 'Monthly',
}).map(([value, label]) => ({ value, label }))

const CampaignHealth = () => {
  const { id } = useParams()
  const { data, isLoading, error } = useCampaignHealth(id)

  // chartAggregation is RHF-owned; useWatch resolves inside the withForm provider.
  const aggregation = useWatch({ name: 'chartAggregation' })
  const chartData = useMemo(() => (data ? getStatsData(data.dailyStats, aggregation) : undefined), [data, aggregation])

  return (
    <div className="campaign-health">
      <LoadingView error={error ? 'Error occurred when loading health data' : undefined} loading={isLoading}>
        <Grid container spacing={2} style={{ marginBottom: 24 }}>
          <Grid size={{ sm: 3 }}>
            <FormSelect
              allowEmpty={false}
              label="Chart aggregation"
              name="chartAggregation"
              options={timeAggregationOptions}
            />
          </Grid>
        </Grid>
        <CampaignHealthStats data={data} />

        <Grid container spacing={2}>
          <Grid size={{ sm: 12 }}>
            <CampaignHealthCharts stats={chartData} />
          </Grid>

          <Grid size={{ sm: 12 }}>
            <Card>
              <CardContent>
                <CampaignHealthTable currency={data?.exchangeCurrency ?? ''} stats={data?.dailyStats} />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </LoadingView>
    </div>
  )
}

export default withForm({
  form: 'campaignHealth',
  initialValues: { chartAggregation: 'daily' },
})(CampaignHealth)
